// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateTeasePopupContent_wrapper__A6S5S"};